import React from 'react'

export default function Currency({ value, children }) {
  const amt = Number(
    value || (typeof children == 'string' && children) || 0
  ).toFixed(2)

  return <span>${amt}</span>
}
